import React from 'react';
import { formatCurrency } from '../../../../utils';
import { CheckMarkDisplayProps } from '../../types';

import mappedIcon from '../../../../assets/images/mappedicon.svg';

const CheckMarkDisplay: React.FC<CheckMarkDisplayProps> = ({
  value,
  formatFunction = formatCurrency,
  title
}) => {
  if (value === 0) {
    return (
      <span title={title || "No discrepancy"} style={{ display: 'flex', justifyContent: 'center' }}>
        <img src={mappedIcon} alt="matched" style={{ width: '20px', height: '20px' }} />
      </span>
    );
  } else {
    return (
      <span
        title={title || `Discrepancy: ${value > 0 ? '+' : ''}${formatFunction(value)}`}
        style={{
          color: value !== 0 ? 'red' : 'green',
          fontWeight: value !== 0 ? 'bold' : 'normal',
          justifyContent: 'end',
          alignItems: 'center',
          display: 'flex',
          fontSize: '0.875rem'
        }}
      >
        {value > 0 ? '+' : ''}{formatFunction(value)}
      </span>
    );
  }
};

export default CheckMarkDisplay;

